export class RegisterUser {
    public UserID: number;
    public UserName: string;
    public UserPassword: string;
    public FirstName: string;
    public LastName: string;
    public Email: string;
    public UserConfirmPassword: string;
}
